'use strict';

angular.module('app.authentication', [])

.factory('AuthenticationService', function ($q, $http, $rootScope, $state, $stateParams, $location, localStorageService, ipCookie, TRACK_EVENTS) {
        var service = {};

        service.Login = function (username, password) {
            var deferred = $q.defer();
            $http.post($rootScope.apiUrl + 'login', { username: username, password: password })
                .success(function(data){
                    deferred.resolve(data);
                })
                .error(function(data, status) {
                    deferred.reject(data, status);
                });

            return deferred.promise;
        };

        service.Logout = function(){
            if (localStorageService.cookie.isSupported) {
                ipCookie.remove('access_token_expiration');
            }
            else {
                localStorageService.remove('access_token_expiration');
            }
            localStorageService.remove('currentUser');
            localStorageService.remove('access_token');
            localStorageService.remove('definitions');
            localStorageService.remove('DiscoverParams');
            localStorageService.remove('isOpen');
            localStorageService.remove('influencerInformation');
            localStorageService.remove('allInfluencerByNetworkCompany');
            $rootScope.saveParams = null;
            $rootScope.sideMenuSelectedName = undefined;
            $rootScope.selectedReportData = undefined;
        }   

        service.LoginByAccessToken = function (access_token) {
            var deferred = $q.defer();

            var req = {
                url: $rootScope.apiUrl + 'loginByToken/' + access_token,
                method: 'GET'
            }

            $http(req)
                .success(function (data) {
                    deferred.resolve(data);
                })
                .error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        service.isAuthenticated = function(roles){
            //if the action does not require login
            if(typeof(roles) === 'undefined' || roles.length == 0)
                return true;

            //check if token has expired
            if (localStorageService.cookie.isSupported) {
                if(typeof(ipCookie("access_token_expiration")) == 'undefined')
                    return false;
            } else {
                if (!localStorageService.get('access_token_expiration')) {
                    return false;
                }
            }

            var currentUser = localStorageService.get('currentUser');

            if(!currentUser || roles.indexOf(currentUser.role.name) < 0){
                console.log("Access not allowed!")
                return false;
            }else{
                $rootScope.currentUser = currentUser;
                service.startIntercom();
                return true;
            }

            return false;
        }

        service.getDefinitions =  function () {
            var deferred = $q.defer();

            $http.get($rootScope.apiUrl + 'definitions', {noCancelOnRouteChange: true}).success(function (response) {
                $rootScope.definitions = response.data;
                $rootScope.definitions.timePeriods = [
                    { id: -2, name: "48 Hours Ago" },
                    { id: 1, name: "Yesterday" },
                    { id: 2, name: "Last 2 Days" },
                    { id: 3, name: "Last 3 Days" },
                    { id: 7, name: "Last Week" },
                    { id: 14, name: "Last 2 Weeks" },
                    { id: 30, name: "Last Month" },
                    { id: 60, name: "Last 2 Months" },
                    { id: 180, name: "Last 6 Months" },
                    { id: 365, name: "Last Year" }
                ];
                localStorageService.set('definitions', $rootScope.definitions);

                // initialize segment 
                var segmentToken = $rootScope.definitions.segmentToken;
                if (segmentToken) {
                    service.loadAnalytics(segmentToken);
                }

                deferred.resolve({status: 'ok'});
            })
            .error(function(data, status) {
                deferred.reject(data);
            });

            return deferred.promise;
        }

        service.startIntercom = function () {
            if($rootScope.currentUser && !$location.search().framed && !$rootScope.isFramed) {
                window.Intercom("boot", {
                    app_id: "fkhiga69",
                    name: $rootScope.currentUser.firstName + " " + $rootScope.currentUser.lastName, // Full name
                    email: $rootScope.currentUser.email, // Email address
                    created_at: $rootScope.currentUser.timestamp // Signup date as a Unix timestamp
                });
            }
        }

        service.defaultRoute = function () {
            if($stateParams.path != null && $stateParams.path != "" && $stateParams.path != undefined) {
                if($stateParams.isurl == null || $stateParams.isurl == "false" || $stateParams.isurl == undefined) {
                    $state.transitionTo($stateParams.path, null, {
                        reload: false,
                        inherit: false,
                        notify: true
                    });
                } else {
                    $location.path(decodeURIComponent($stateParams.path));
                }
            } else {
                if($rootScope.currentUser.role.accessLevel == 'admin') {
                    $location.path('/admin/content');
                } else if($rootScope.currentUser.role.accessLevel == 'achooAnalyst') {
                    $location.path('/admin/influencersPending');
                } else {
                    $location.path('/dashboard');
                }
            }
        }

        service.identifyAnalytics = function (userData) {
            analytics.identify(userData.id, {
                // people properties
                name: userData.fullName,
                email: userData.email,
                created: userData.createdAt,
                last_login: new Date().toISOString(),
                // super properties
                user_id: userData.id,
                user_name: userData.fullName,
                user_company_id: userData.company.id,
                user_company_name: userData.company.name,
                currently_active_company_name: userData.company.name,
                currently_active_company_id: userData.company.id,
                user_role: userData.role.name,
                user_creation_date: new Date(userData.modifiedAt).toISOString(),
                user_company_account_type: (userData.company.companyType.name.match(/Agency/)? 'Agency' : userData.company.companyType.name),
                user_company_account_sub_type: userData.company.companyType.name
            });
        }

        service.loadAnalytics = function (token) {
            if (analytics && angular.isFunction(analytics.load) && $rootScope.currentUser) {
                analytics.load(token);
            }
        }

        service.reloadCurrentUser = function () {
            var deferred = $q.defer();

            $http.get($rootScope.apiUrl + 'me', {noCancelOnRouteChange: true})
                .success(function (response) {
                    var userData = response.data;
                    userData.timestamp = (new Date()).getTime();
                    service.SetUserAccessibility(userData);

                    $rootScope.currentUser = userData;
                    localStorageService.set('currentUser', $rootScope.currentUser);

                    service.identifyAnalytics(userData);

                    service.startIntercom();

                    if(userData.role.accessLevel == "network") {
                        deferred.resolve({status: 'ok'});
                        // Network Information
                        // $http.get($rootScope.apiUrl + 'network/getAllInfluencerByNetworkCompany/' + userData.company.id, {noCancelOnRouteChange: true})
                        //     .success(function (response) {
                        //         $rootScope.allInfluencerByNetworkCompany = response.data;
                        //         localStorageService.set('allInfluencerByNetworkCompany', $rootScope.allInfluencerByNetworkCompany);
                        //         deferred.resolve({status: 'ok'});
                        //     })
                        //     .error(function(data, status) {
                        //         deferred.reject(data);
                        //     });
                    } else {
                        if(userData.role.accessLevel == "influencer") {
                            // Influencer Information
                            $http.get($rootScope.apiUrl + 'influencer/getInfluencerInformation/' + userData.company.id, {noCancelOnRouteChange: true})
                                .success(function(response){
                                    $rootScope.influencerInformation = response.data;
                                    localStorageService.set('influencerInformation', $rootScope.influencerInformation);
                                    deferred.resolve({status: 'ok'});
                                })
                                .error(function(data, status) {
                                    deferred.reject(data);
                                });
                        } else {
                            deferred.resolve({status: 'ok'});
                        }
                    }
                })
                .error(function(data, status) {
                    deferred.reject(data);
                });

            return deferred.promise;
        }

        service.getCurrentUser = function (loading) {

            return $http.get($rootScope.apiUrl + 'me', {noCancelOnRouteChange: true})
                .success(function (response) {
                    var userData = response.data;
                    userData.timestamp = (new Date()).getTime();
                    service.SetUserAccessibility(userData);

                    $rootScope.currentUser = userData;
                    localStorageService.set('currentUser', $rootScope.currentUser);

                    service.identifyAnalytics(userData);

                    analytics.track(TRACK_EVENTS.LOGIN.EVT_NAME);

                    service.startIntercom();

                    if(userData.role.accessLevel == "network") {
                        // Network Information
                        $http.get($rootScope.apiUrl + 'network/getAllInfluencerByNetworkCompany/' + userData.company.id, {noCancelOnRouteChange: true})
                            .success(function (response) {
                                $rootScope.allInfluencerByNetworkCompany = response.data;
                                localStorageService.set('allInfluencerByNetworkCompany', $rootScope.allInfluencerByNetworkCompany);
                                loading = false;
                                service.defaultRoute();
                            })
                    } else {
                        if(userData.role.accessLevel == "influencer") {
                            // Influencer Information
                            $http.get($rootScope.apiUrl + 'influencer/getInfluencerInformation/' + userData.company.id, {noCancelOnRouteChange: true})
                                .success(function(response){
                                    $rootScope.influencerInformation = response.data;
                                    localStorageService.set('influencerInformation', $rootScope.influencerInformation);
                                    loading = false;
                                    service.defaultRoute();
                            })
                        } else {
                            loading = false;
                            service.defaultRoute();
                        }
                    }
                })
        }

        service.SetUserAccessibility = function (userData) {
            var userRole = userData.role.id;
            var companyType = userData.company != null ? userData.company.companyType.id : null;
            var packageSub = 'ENTERPRISE';

            // Admin
            if(userRole == 1) {
                userData.role.accessLevel = "admin";
                userData.accessibility = {
                    header: {
                        showHome: true,
                        showDiscover: true,
                        showMeasure: true,
                        showInfluencerGroup: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? true : false,
                        showCampaign: true
                    },
                    leftMenu: {
                        showCurrentlyManaging: true,
                        showProjects: true,
                        showPreferred: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? false : true,
                        showChannels: false,
                        showNetworks: false,
                        showInfluencerGroup: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? true : false,
                        showCampaigns: true,
                    },
                    profile: {
                        showDefaultSetting: true,
                        showInfluencerSetting: false,
                        showNotification: true,
                        showBilling: true,
                        showManageChannels: false,
                        showManageInfluencer: false,
                        showAdminMenu: true
                    },
                    discoverPage: {
                        showAdvancePreferred: true,
                        showAdvanceInfluencerGroup: true
                    }
                };
            } else if(userRole == 2) {
                //User
                switch (companyType) {
                    case 1:
                        // Advertiser
                        userData.role.accessLevel = "advertiser";
                        userData.accessibility = {
                            header: {
                                showHome: true,
                                showDiscover: true,
                                showMeasure: true,
                                showInfluencerGroup: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? true : false,
                                showCampaign: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? true : false
                            },
                            leftMenu: {
                                showCurrentlyManaging: false,
                                showProjects: true,
                                showPreferred: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? false : true,
                                showChannels: false,
                                showNetworks: false,
                                showInfluencerGroup: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? true : false,
                                showCampaigns: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? true : false,
                            },
                            profile: {
                                showDefaultSetting: true,
                                showInfluencerSetting: false,
                                showNotification: true,
                                showBilling: true,
                                showManageChannels: false,
                                showManageInfluencer: false,
                                showAdminMenu: false
                            },
                            discoverPage: {
                                showAdvancePreferred: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? false : true,
                                showAdvanceInfluencerGroup: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? true : false
                            }
                        };
                        break;
                    case 2:
                    case 3:
                    case 4:
                        // Agency
                        userData.role.accessLevel = "agency";
                        userData.accessibility = {
                            header: {
                                showHome: true,
                                showDiscover: true,
                                showMeasure: true,
                                showInfluencerGroup: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? true : false,
                                showCampaign: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? true : false
                            },
                            leftMenu: {
                                showCurrentlyManaging: true,
                                showProjects: true,
                                showPreferred: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? false : true,
                                showChannels: false,
                                showNetworks: false,
                                showInfluencerGroup: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? true : false,
                                showCampaigns: packageSub == 'ENTERPRISE' || packageSub == 'PRO' ? true : false,
                            },
                            profile: {
                                showDefaultSetting: true,
                                showInfluencerSetting: false,
                                showNotification: true,
                                showBilling: true,
                                showManageChannels: false,
                                showManageInfluencer: false,
                                showAdminMenu: false
                            },
                            discoverPage: {
                                showAdvancePreferred: true,
                                showAdvanceInfluencerGroup: true
                            }
                        };
                        break;
                    case 5:
                        // Network
                        userData.role.accessLevel = "network";
                        userData.accessibility = {
                            header: {
                                showHome: true,
                                showDiscover: false,
                                showMeasure: true,
                                showInfluencerGroup: false,
                                showCampaign: false
                            },
                            leftMenu: {
                                showCurrentlyManaging: false,
                                showProjects: false,
                                showPreferred: false,
                                showChannels: false,
                                showNetworks: true,
                                showInfluencerGroup: false,
                            },
                            profile: {
                                showDefaultSetting: true,
                                showInfluencerSetting: false,
                                showNotification: false,
                                showBilling: false,
                                showManageChannels: false,
                                showManageInfluencer: true,
                                showAdminMenu: false
                            },
                            discoverPage: {
                                showAdvancePreferred: true,
                                showAdvanceInfluencerGroup: false
                            }
                        };
                        break;
                    case 6:
                        // Influencer
                        userData.role.accessLevel = "influencer";
                        userData.accessibility = {
                            header: {
                                showHome: true,
                                showDiscover: false,
                                showMeasure: true,
                                showInfluencerGroup: false,
                                showCampaign: true
                            },
                            leftMenu: {
                                showCurrentlyManaging: false,
                                showProjects: false,
                                showPreferred: false,
                                showChannels: true,
                                showNetworks: false,
                                showInfluencerGroup: false,
                                showCampaigns: false,
                            },
                            profile: {
                                showDefaultSetting: false,
                                showInfluencerSetting: true,
                                showNotification: false,
                                showBilling: false,
                                showManageChannels: true,
                                showManageInfluencer: false,
                                showAdminMenu: false
                            },
                            discoverPage: {
                                showAdvancePreferred: true,
                                showAdvanceInfluencerGroup: false
                            }
                        };
                        break;
                }
            } else {
                //Achoo Analyst
                userData.role.accessLevel = "achooAnalyst";
                userData.accessibility = {
                    header: {
                        showHome: false,
                        showDiscover: false,
                        showMeasure: false,
                        showInfluencerGroup: false,
                        showCampaign: false
                    },
                    leftMenu: {
                        showCurrentlyManaging: false,
                        showProjects: false,
                        showPreferred: false,
                        showChannels: false,
                        showNetworks: false,
                        showInfluencerGroup: false
                    },
                    profile: {
                        showDefaultSetting: true,
                        showInfluencerSetting: false,
                        showNotification: false,
                        showBilling: true,
                        showManageChannels: false,
                        showManageInfluencer: false,
                        showAdminMenu: true
                    },
                    discoverPage: {
                        showAdvancePreferred: false,
                        showAdvanceInfluencerGroup: false
                    }
                };
            }
        };

        return service;
})
